import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TimeLine from './components/TimeLine';
import HotRanking from './components/HotRanking';
import Topics from './components/Topics';
import Essence from './components/Essence';
import About from './components/About';
import Faq from './components/Faq';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TimeLine />
        <HotRanking />
        <Topics />
        <Essence />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}